<style scoped>
.v-application .text-h4 {
  font-family: "Prompt", sans-serif !important;
  font-size: 24px !important;
}
.text-spacing {
  letter-spacing: 0px !important;
}
.v-application .white {
  border: #ccd0d9 solid 1px !important;
}
.v-data-table__wrapper > table > thead > tr {
  background-color: #039be5;
}
.v-data-table__wrapper > table > thead > tr > th {
  font-size: 14px;
  color: white !important;
}
</style>

<template>
  <div>
    <v-layout class="d-flex justify-space-between">
      <div
        class="text-h4 font-weight-black primary--text text-spacing"
        color="blue"
      >
        ทะเบียนรายชื่อลูกค้า
      </div>
      <v-spacer></v-spacer>

      <!-- <v-btn color="success" elevation="0" dark link @click="insert_customer()">
        <v-icon left>mdi-file-plus</v-icon>เพิ่มลูกค้าใหม่
      </v-btn> -->
    </v-layout>
    <v-divider class="my-2"></v-divider>
    <filterCustomer
      :isfromNew="isfromNew"
      v-on:returnDessert="clickReturn"
      :fromPage="'customer'"
    >
    </filterCustomer>
    <v-layout class="mb-2" justify-end>
      <!-- <v-btn color="white excel-border" elevation="0" light>
        <v-icon left>mdi-printer</v-icon>ดาวน์โหลด excel
      </v-btn> -->
    </v-layout>
    <!--  <v-row>
      <v-col></v-col>
      <v-col>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-col>
    </v-row>-->
    <v-data-table
      :headers="headers"
      :items="getIndex"
      :items-per-page="15"
      item-key="index"
    >
      <template #item="{ item }">
        <tr>
          <td>
            <span>
              {{ item.index }}
            </span>
            <span
              class="mx-2"
              v-if="item.BILL_ID != null && item.DOC_STATUS != 'เก็บเงินแล้ว'"
            >
              <v-icon color="red" dark @click="debt_history(item)">
                mdi-file-alert-outline
              </v-icon>

              <!-- <v-menu max-width="220" offset-x open-on-hover>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="red" dark v-bind="attrs" v-on="on">
                    mdi-file-alert-outline
                  </v-icon>
                </template>
                <v-card>
                  <v-list class="ma-n1">
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title style="font-size: 16px"
                          >ยอดค้างชำระ</v-list-item-title
                        >
                        <v-divider class="my-1"></v-divider>
                        <v-list-item-subtitle>
                          รหัสใบแจ้งหนี้
                          {{ item.DEPOSIT_VALUE }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle>
                          ยืมถัง {{ item.BORROW_VALUE }} ถัง
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>

                  <v-divider></v-divider>
                </v-card>
              </v-menu> -->
            </span>
          </td>
          <td>{{ item.NEWCUSTOMER_ID }}</td>
          
          <td>
            {{ item.CREATE_DATE | formatDate }}
          </td>
          <td>
            <p class="mt-1 mb-n1" style="font-weight: bold">
              {{ item.CUSTOMER_NAME }}
            </p>
            <p class="mb-n1 mt-1" style="font-size: 12px">{{ item.NOTE }}</p>
            <p
              v-if="item.ISDEPOSIT == 1 || item.ISBORROW == 1"
              class="mb-1 mt-1"
              style="font-size: 12px; color: blue"
            >
              <span v-if="item.ISDEPOSIT == 1">
                มัดจำประมูลงาน {{ item.DEPOSIT_VALUE | delimeter }} บาท
              </span>
              <span v-if="item.ISBORROW == 1"
                >ยืมถัง {{ item.BORROW_VALUE }} ถัง
              </span>
            </p>
          </td>
          <!-- <td>{{ item.PROVIDER_NAME }}</td> -->
          <td>{{ item.PROVIDER_PHONE }}</td>
          <td>{{ item.CONTRACT_CATEGORY }}</td>
          <td>
            {{
              item.CUSTOMER_TYPE != "อื่นๆ"
                ? item.CUSTOMER_TYPE
                : item.CUSTOMER_TYPE_OTHER
                ? item.CUSTOMER_TYPE + "(" + item.CUSTOMER_TYPE_OTHER + ")"
                : ""
            }}
          </td>
          <td>
            <span class="mx-2" v-if="item.SPLIT_PAY == 1 && item.BILL_ID">
              <v-icon color="pink lighten-2" dark @click="split_history(item)">
                mdi-information
              </v-icon>
            </span>
            <span v-else class="mx-5"></span>
            <CustomerStatus :TableData="item"></CustomerStatus>
          </td>
          <td>
            <TableMenuCustomer
              :TableData="item"
              :whichPage="'regis_cus'"
            ></TableMenuCustomer>
          </td>
        </tr>
      </template>

      <!-- <template v-slot:item.actions="{ item }">
        <TableMenuCustomer
          :TableData="item"
          :whichPage="'regis_cus'"
        ></TableMenuCustomer>
      </template> -->

      <!-- <template
        v-slot:item.CONTRACT_START_DATE="{ item }"
      >{{ contract_expier(item.CONTRACT_START_DATE,item.CONTRACT_END_DATE) }}</template>
      <template v-slot:item.CONTRACT_END_DATE="{ item }">{{ item.CONTRACT_END_DATE | thdate }}</template> -->

      <template v-slot:no-data>
        <v-btn color="info" @click="initialize">
          <v-icon left>mdi-refresh</v-icon>รีเฟรชข้อมูล
        </v-btn>
      </template>
    </v-data-table>
    <v-dialog v-model="dialog" max-width="650">
      <v-card>
        <v-card-title class="text-h4 subtitle-1 font-weight-bold info--text">
          ประวัติการแบ่งจ่าย
        </v-card-title>

        <v-card-text>
          <v-subheader class="ml-n3 mt-n4"
            >ใบเสนอราคา {{ paid_history.QUOTATION_ID }}</v-subheader
          >
          <v-banner elevation="1" color="grey lighten-4">
            <v-row>
              <v-col cols="12" lg="6" class="my-n2">มูลค่าที่ต้องชำระ</v-col>
              <v-col cols="12" lg="6" class="my-n2">{{
                paid_history.TOTAL_PAID | delimeter
              }}</v-col>
              <v-col cols="12" lg="6" class="my-n2">เรียกเก็บแล้ว</v-col>
              <v-col cols="12" lg="6" class="my-n2">{{
                paid_history.PAID | delimeter
              }}</v-col>
              <v-col cols="12" lg="6" class="my-n2">ยังไม่ได้เรียกเก็บ</v-col>
              <v-col cols="12" lg="6" class="my-n2">{{
                paid_history.LEFTOVER | delimeter
              }}</v-col>
              <v-divider class="my-3"></v-divider>
              <v-col cols="12" lg="6" class="my-n2"
                >สถานะการเรียกเก็บเงิน</v-col
              >
              <v-col cols="12" lg="6" class="my-n2"
                >{{ paid_history.PERCENT_COLLECT }} %</v-col
              >
            </v-row>
          </v-banner>
          <v-simple-table dense class="mt-4">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left" style="width: 3%">ลำดับ</th>
                  <th class="text-left">เลขที่อ้างอิง</th>
                  <th class="text-left">วันที่เอกสาร</th>
                  <th class="text-left">ยอดรวมก่อนภาษี</th>
                  <th class="text-left">มูลค่าที่ต้องชำระ</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in billIndex" :key="item.index">
                  <td>{{ item.index }}</td>
                  <td>{{ item.BILL_ID }}</td>
                  <td>{{ item.CREATE_DATE | formatDate }}</td>
                  <td class="text-right">
                    {{ item.PAID_NO_VAT | delimeter }}
                  </td>
                  <td class="text-right">
                    {{ item.PAID_VAT | delimeter }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="dialog = false"> ปิดหน้าต่าง </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="linkDialog" max-width="650">
      <v-card>
        <v-card-title class="text-h4 subtitle-1 font-weight-bold info--text">
          ลิงค์ข้อมูลลูกค้า
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="12" lg="12">
              <v-text-field
                outlined
                dense
                :value="customerLink"
                ref="textToCopy"
                :append-icon="'mdi-content-copy'"
                @click:append="copyLink"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>

        <v-snackbar v-model="snackbar" centered :timeout="2000">
          คัดลอกลิงค์แล้ว
        </v-snackbar>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_debt" max-width="800">
      <v-card>
        <v-card-title class="text-h4 subtitle-1 font-weight-bold info--text">
          ยอดค้างชำระทั้งหมด
        </v-card-title>

        <v-card-text>
          <v-simple-table dense class="mt-4">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left" style="width: 3%">ลำดับ</th>
                  <th class="text-left">ใบเสนอราคา</th>
                  <th class="text-left">เลขที่อ้างอิง</th>
                  <th class="text-left">วันที่เอกสาร</th>
                  <th class="text-left">ยอดรวมก่อนภาษี</th>
                  <th class="text-left">มูลค่าที่ต้องชำระ</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in debtIndex" :key="item.index">
                  <td>{{ item.index }}</td>
                  <td>{{ item.QUOTATION_ID }}</td>
                  <td>{{ item.BILL_ID }}</td>
                  <td>{{ item.CREATE_DATE | formatDate }}</td>
                  <td class="text-right">
                    {{ item.PAID_NO_VAT | delimeter }}
                  </td>
                  <td class="text-right">
                    {{ item.PAID_VAT | delimeter }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="dialog_debt = false">
            ปิดหน้าต่าง
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import TableMenuCustomer from "../../components/TableMenuCustomer";
import CustomerStatus from "../../components/CustomerStatus";
import filterCustomer from "../../components/filterCustomer";
import moment from "moment";
import { mapMutations, mapActions } from "vuex";
export default {
  components: {
    TableMenuCustomer,
    CustomerStatus,
    filterCustomer,
  },
  data() {
    return {
      dialog: false,
      customerLink: "",
      snackbar: false,
      linkDialog: false,
      QRcolor: "blue",
      isfromNew: false,
      search: "",
      dialog_debt: false,
      bill_history: [],
      debt_data: [],
      paid_history: {},
      singleSelect: false,
      selected: [],
      headers: [
        {
          text: "ลำดับ",
          align: "start",
          value: "index",
          width: "90",
        },
        {
          text: "รหัสลูกค้า",
          align: "start",
          sortable: true,
          value: "NEWCUSTOMER_ID",
          width: "100",
        },
        { text: "วันที่เข้าระบบ", value: "CREATE_DATE", width: "120" },
        {
          text: "รายชื่อ",
          align: "start",
          width: "200",
          sortable: false,
          value: "CUSTOMER_NAME",
        },
        // { text: "ชื่อผู้ติดต่อ", value: "PROVIDER_NAME" },
        { text: "เบอร์โทร", value: "PROVIDER_PHONE", width: "120" },
        { text: "สัญญา", value: "PROVIDER_EMAIL", width: "120" },
        { text: "ประเภท", value: "CUSTOMER_TYPE", width: "150" },
        {
          text: "สถานะ",
          value: "STATUS",
          sortable: true,
          width: "160",
          align: "center",
        },
        { text: "การจัดการ", value: "actions", width: "90", sortable: false },
      ],
      desserts: [],
    };
  },
  filters: {
    delimeter(data) {
      let y = parseFloat(data).toFixed(2);
      let x = y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      return x == "NaN" ? 0 : x;
    },
    formatDate(data) {
      return moment(data).format("DD-MM-YYYY");
    },
  },
  computed: {
    // count index in table and chang date format
    getIndex() {
      return this.desserts.map((item, index) => ({
        ...item,
        index: index + 1,
        // create_date: moment(CREATE_DATE)
        //   .add(543, "years")
        //   .format("DD/MM/YYYY hh:mm:ss", true),
      }));
    },
    billIndex() {
      return this.bill_history.map((item, index) => ({
        ...item,
        index: index + 1,
      }));
    },
    debtIndex() {
      return this.debt_data.map((item, index) => ({
        ...item,
        index: index + 1,
      }));
    },
  },
  created() {
    this.listOldcustomer();
    //this.list_c_period();
  },
  methods: {
    ...mapActions({
      SET_DAYS: "CustomerDetail/addTran",
      INIT_DAYS: "CustomerDetail/initDays",
    }),
    ...mapMutations({
      LOADER: "Drawer/SET_LOADER",
    }),
    initialize() {
      this.listOldcustomer();
    },
    split_history(item) {
      this.dialog = true;
      this.$token_api
        .post("/view-split-history", { NEWCUSTOMER_ID: item.NEWCUSTOMER_ID })
        .then((response) => {
          let data = response.data;
          if (data.length > 0) {
            this.paid_history = data[0];
            this.bill_history = data[0].LIST_BILL;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    showDialog(id) {
      this.linkDialog = true;
      this.customerLink = `${this.$global_link}/Customer/${id}`;
    },
    debt_history(item) {
      this.dialog_debt = true;
      this.$token_api
        .post("/view-debt-history", { NEWCUSTOMER_ID: item.NEWCUSTOMER_ID })
        .then((response) => {
          let data = response.data;
          if (data.length > 0) {
            this.debt_data = data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    startload() {
      this.$store.commit("Drawer/SET_LOADER", true);
      this.LOADER(true);
    },
    stopload() {
      this.LOADER(false);
    },
    insert_customer() {
      this.$router.push({ path: "/newCustomer/add-newCustomer" });
      this.$store.commit("CustomerDetail/SET_IS_EDIT", "Admin");
      this.INIT_DAYS();
    },
    editItem(item) {
      //this.$swal("แก้ไขข้อมูล", "เข้าสู่การแก้ไขข้อมูล", "info");
      //console.log(item)
      //console.log(item.CUSTOMER_ID);
      this.$store.commit("CustomerDetail/SET_DT_CUSTOMER_ID", item.CUSTOMER_ID);
      this.$store.commit(
        "CustomerDetail/SET_DT_CUSTOMER_NAME",
        item.CUSTOMER_NAME
      );
      this.$store.commit(
        "CustomerDetail/SET_DT_CUSTOMER_TYPE",
        item.CUSTOMER_TYPE
      );
      this.$store.commit(
        "CustomerDetail/SET_DT_CUSTOMER_BRANCH",
        item.CUSTOMER_BRANCH
      );
      //--------- commit 3 store - CustomerDT - Quotation - Contract ------------
      this.$store.commit(
        "CustomerDetail/SET_DT_CUSTOMER_ADRESS",
        item.CUSTOMER_ADDRESS
      );
      this.$store.commit(
        "CustomerDetail/SET_DT_CUSTOMER_SUBDISTRICT",
        item.CUSTOMER_SUBDISTRICT
      );
      this.$store.commit(
        "CustomerDetail/SET_DT_CUSTOMER_DISTRICT",
        item.CUSTOMER_DISTRICT
      );
      this.$store.commit(
        "CustomerDetail/SET_DT_CUSTOMER_PROVINCE",
        item.CUSTOMER_PROVINCE
      );
      this.$store.commit(
        "CustomerDetail/SET_DT_CUSTOMER_ZIPCODE",
        item.CUSTOMER_ZIPCODE
      );
      // ------------------------------------------------------------
      this.$store.commit(
        "CustomerDetail/SET_DT_CUSTOMER_TEXID",
        item.CUSTOMER_TAX_ID
      );
      this.$store.commit(
        "CustomerDetail/SET_DT_CUSTOMER_OWNER_NAME",
        item.PROVIDER_NAME
      );
      this.$store.commit(
        "CustomerDetail/SET_DT_CUSTOMER_PHONE",
        item.PROVIDER_PHONE
      );
      this.$store.commit(
        "CustomerDetail/SET_DT_CUSTOMER_EMAIL",
        item.PROVIDER_EMAIL
      );
      this.$store.commit(
        "CustomerDetail/SET_DT_CUSTOMER_LINEID",
        item.PROVIDER_LINE_ID
      );
      this.$store.commit(
        "CustomerDetail/SET_DT_CUSTOMER_FACEBOOK",
        item.PROVIDER_FACEBOOK
      );
      this.$store.commit(
        "CustomerDetail/SET_DT_CUSTOMER_LINEUSERID",
        item.LINE_USERID
      );
      this.$store.commit("CustomerDetail/SET_MARKERS", {
        lat: item.LATS,
        lng: item.LONGS,
      });
      this.$store.commit("CustomerDetail/SET_IS_EDIT", true);

      //console.log(this.$store.getters["CustomerDetail/GET_DT_MARKERS"])
      //console.log(this.$store.getters["CustomerDetail/IS_EDIT"])
      this.$router.push({ path: "/newCustomer/add-newCustomer" });
    },
    deleteItem(item) {
      const _this = this;
      this.$token_api
        .delete("/delete-Customer", {
          data: { CON_ID: item.CUSTOMER_ID },
        })
        .then((response) => {
          _this.listOldcustomer();
          this.$swal("ลบลูกค้า", "ลูกค้าเรียบร้อย", "question");
        })
        .catch((err) => {});
    },
    copyLink() {
      let textToCopy = this.$refs.textToCopy.$el.querySelector("input");
      textToCopy.select();
      document.execCommand("copy");
      this.snackbar = true;
    },
    listOldcustomer() {
      this.$token_api
        .post("/list-all-oldCustomer", {
          STATUS: "%",
          STATUS2: "%",
          STATUS3: "%",
        })
        .then((response) => {
          let x = response.data.data;
          // x.map((x)=>{ console.log(x.DOC_STATUS != 'เก็บเงินแล้ว')})
          this.desserts = response.data.data;
          console.log(this.desserts);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    clickReturn(val) {
      this.desserts = val;
    },
    print_QRcode(item) {
      console.log(item);
    },
  },
};
</script>